module.exports = __webpack_public_path__ + "static/media/outdoor_outfitter_multiple_concepts_for_store_mural_2013.5a33d521.webp";